import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import { strings } from '../../resources/strings';
import './ServiceOnDemandSchedules.css';

export class ServiceOnDemandSchedules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
            schedules: []
        };
    }

    componentDidMount() {
        fetch(`${process.env.PUBLIC_URL}/docs/schedules/schedules-config.json`)
            .then(response => response.json())
            .then(schedules => this.setState({ schedules }));
    }

    render() {
        const { search, schedules } = this.state;

        const filteredSchedules = schedules
            .filter(s => s.lineCode.toLowerCase().indexOf(search.toLowerCase()) > -1)
            .sort((a, b) => a.lineCode.localeCompare(b.lineCode, undefined, { numeric: true }) || a.date.localeCompare(b.date));

        return (
            <div className="service-on-demand-schedules">
                <h4>{strings.serviceOnDemandSchedulesTitle}</h4>
                <FormControl
                    className="service-on-demand-schedules-search margin-bottom-10"
                    placeholder={strings.serviceOnDemandSchedulesSearchPlaceholder}
                    value={search}
                    onChange={e => this.setState({ search: e.target.value })}
                />
                <div className="service-on-demand-schedules-scroll">
                    <table className="service-on-demand-schedules-table">
                        <thead>
                            <tr>
                                <th>{strings.serviceOnDemandSchedulesLineColumn}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredSchedules.map(s =>
                                    <tr key={s.fileName}>
                                        <td><b>{s.lineCode}</b></td>
                                        <td>
                                            <a
                                                className="service-on-demand-schedules-download"
                                                href={`docs/schedules/${s.fileName}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {strings.serviceOnDemandSchedulesDownload}
                                            </a>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    {
                        filteredSchedules.length === 0 &&
                        <div className="service-on-demand-schedules-empty">
                            {strings.serviceOnDemandSchedulesEmpty}
                        </div>
                    }
                </div>
            </div>
        );
    }
}
